import type { TimelineItem } from "./timeline";

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

function toTimestamp(value?: string | null): number | null {
  if (!value) return null;

  const dateOnlyMatch = DATE_ONLY_PATTERN.exec(value);
  const timestamp = dateOnlyMatch
    ? new Date(
        Number(dateOnlyMatch[1]),
        Number(dateOnlyMatch[2]) - 1,
        Number(dateOnlyMatch[3]),
      ).getTime()
    : new Date(value).getTime();

  return Number.isNaN(timestamp) ? null : timestamp;
}

function getTimelineEndTimestamp(item: TimelineItem): number | null {
  if (item.ongoing_derived) return Date.now();
  return toTimestamp(item.end_date ?? item.start_date);
}

export function getEarliestTimelineDate(items: TimelineItem[]) {
  const timestamps = items
    .map((item) => toTimestamp(item.start_date))
    .filter((timestamp): timestamp is number => timestamp !== null);

  if (!timestamps.length) return null;
  return new Date(Math.min(...timestamps));
}

export function getLatestTimelineDate(items: TimelineItem[]) {
  const timestamps = items
    .map((item) => getTimelineEndTimestamp(item))
    .filter((timestamp): timestamp is number => timestamp !== null);

  if (!timestamps.length) return null;
  return new Date(Math.max(...timestamps));
}
